import {
  USER_INTERFACE_PASSWORD_EYE_SHOW,
  TIME_LOCATION_BED,
  FOOD_BEVERAGE_MEAL_PACKAGE,
  ACTIVITY_POOL,
  ACTIVITY_SPINNING,
  ACTIVITY_SPA,
  TIME_LOCATION_COMBINATION,
  TIME_LOCATION_MAP_ROUTE,
  WEATHER_PARTLY_CLOUDY,
  COMMUNICATION_REVIEW,
  MISC_ENVIRONMENT,
  USER_CHILD,
  MISC_MICROPHONE,
  TIME_LOCATION_MAIN_CENTER,
} from '@bwoty-web/styleguide';

export const sectionKeys = {
  accommodation: 'accommodation',
  foodAndBeverage: 'foodAndBeverage',
  poolAndBeach: 'poolAndBeach',
  sportsRelaxationEntertainment: 'sportsRelaxationEntertainment',
  spa: 'spa',
  kidsFacilities: 'kidsFacilities',
  locationAndTransfer: 'locationAndTransfer',
  rating: 'rating',
  map: 'map',
  weather: 'weather',
  show: 'show',
  sustainability: 'sustainability',
  overview: 'overview',
  description: 'description',
};

export const sectionIcons = {
  accommodation: TIME_LOCATION_BED,
  foodAndBeverage: FOOD_BEVERAGE_MEAL_PACKAGE,
  poolAndBeach: ACTIVITY_POOL,
  sportsRelaxationEntertainment: ACTIVITY_SPINNING,
  spa: ACTIVITY_SPA,
  kidsFacilities: USER_CHILD,
  locationAndTransfer: TIME_LOCATION_COMBINATION,
  rating: COMMUNICATION_REVIEW,
  map: TIME_LOCATION_MAP_ROUTE,
  weather: WEATHER_PARTLY_CLOUDY,
  show: MISC_MICROPHONE,
  sustainability: MISC_ENVIRONMENT,
  overview: USER_INTERFACE_PASSWORD_EYE_SHOW,
  description: TIME_LOCATION_MAIN_CENTER,
};

// Image sections to show in the gallery, order is important
// Possible to move to Umbraco, consider it
export const imageSections = {
  video: ['video'],
  description: ['hotel', 'lounge', 'interior'],
  accommodation: ['bathroom', 'bedroom'],
  foodAndBeverage: ['restaurant', 'food'],
  poolAndBeach: ['pool', 'beach'],
  sportsRelaxationEntertainment: [
    'gym',
    'activity',
    'sport',
    'spa',
    'entertainment',
  ],
  kids: ['kids'],
  locationAndTransfer: ['transport', 'bus', 'plane', 'car'],
  bathroom: ['bathroom'],
  sustainability: ['esg'],
};

export const imageSectionsArray = [
  { key: 'video', includeCategories: ['video'] },
  { key: 'description', includeCategories: ['hotel', 'lounge', 'interior'] },
  { key: 'accommodation', includeCategories: ['bathroom', 'bedroom'] },
  { key: 'foodAndBeverage', includeCategories: ['restaurant', 'food'] },
  { key: 'poolAndBeach', includeCategories: ['pool', 'beach'] },
  {
    key: 'sportsRelaxationEntertainment',
    includeCategories: ['gym', 'activity', 'sport', 'entertainment', 'spa'],
  },
  { key: 'kids', includeCategories: ['kids'] },
  {
    key: 'locationAndTransfer',
    includeCategories: ['transport', 'bus', 'plane', 'car'],
  },
  { key: 'bathroom', includeCategories: ['bathroom'] },
  { key: 'sustainability', includeCategories: ['esg'] },
];
